<template>
    <v-card v-if="sms_consent">
        <v-card-title>{{ sms_consent.title }}</v-card-title>
        <v-card-text v-html="sms_consent.content">
        </v-card-text>
    </v-card>
</template>

<script>
import axios                 from "axios";
export default {
    name: "SmsConsent",
    computed:{
        sms_consent(){
            const sms_consent = this.$store.state.resources.policy_and_terms.sms_consent;
            sms_consent.content = sms_consent.content.replaceAll('\\r','').replaceAll('\\n','');
            return sms_consent;
        },
    },
}
</script>
